import { render, staticRenderFns } from "./RegistrationBanner.vue?vue&type=template&id=c522b8ee&scoped=true"
import script from "./RegistrationBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrationBanner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RegistrationBanner.vue?vue&type=style&index=0&id=c522b8ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c522b8ee",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CBtn: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBtn/CBtn.vue').default,CCard: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CCard/CCard.vue').default})
